export const LOAD_PRODUCT = 'LOAD_PRODUCT'
export const LOADING_PRODUCT = 'LOADING_PRODUCT'
export const LOAD_PRODUCT_SUCCEEDED = 'LOAD_PRODUCT_SUCCEEDED'
export const LOAD_PRODUCT_FAILED = 'LOAD_PRODUCT_FAILED'


export function loadProducts() {
    return { type: LOAD_PRODUCT }
}
